import * as React from 'react';
import classNames from 'classnames';

import './style.scss';

interface Props {
  id?: string;
  fieldsetValue: any;
  onChange: (e: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) => void;
  onFocus: (e: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) => void;
  placeholder: string;
  type: string;
  disabled: boolean;
  secondPage?: boolean;
  error?: boolean;
}

const FieldsetForm = (props: Props) => {

  const {
    fieldsetValue,
    secondPage,
    placeholder,
    disabled,
    type,
    onFocus,
    onChange,
    id,
  } = props;

  const fieldSetClassName = classNames('form-fieldset', {
    'form-fieldset-active' : fieldsetValue,
    'form-fieldset-empty' : !fieldsetValue,
    'form-second-fieldset': !!secondPage,
  });

  const legendClassName = classNames({
    'form-legend': fieldsetValue,
    'form-legend-empty': !fieldsetValue,
  });

  const inputClassName = classNames({
    'form-input': !secondPage,
    'form-second-input': secondPage,
  });

  return(
    <fieldset className={fieldSetClassName}>
      <legend className={legendClassName}>
        {fieldsetValue ? placeholder : null}
      </legend>
      <input
        id={id}
        onChange={onChange}
        onFocus={onFocus}
        value={fieldsetValue}
        className={inputClassName}
        placeholder={placeholder}
        type={type}
        disabled={disabled} />
    </fieldset>
  );
};

export default FieldsetForm;
